import { Component } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterEvent } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { CinemaDataProvider } from 'libs/core/src/lib/data-provider/cinema.data-provider';
import { LanguageDataProvider } from 'libs/core/src/lib/data-provider/language.data-provider';
import { MessageService } from 'libs/core/src/lib/service/message.service';
import { CoreRequestHandlerService } from 'libs/core/src/lib/service/request-handler/core/core-request-handler.service';
import { CoreComponent } from 'libs/shared/src/lib/component/core.component';
import { environment } from 'apps/cinema1/src/environments/environment';
import { LoaderService } from 'libs/core/src/lib/service/loading.service';
import { StateService } from 'libs/core/src/lib/state/state.service';
import { LoaderEnum } from 'libs/core/src/lib/enum/loader.enum';
import { filter } from 'rxjs';
import { storageKey } from '@lib/core';

@Component({ standalone: false, selector: 'app-core', templateUrl: './core.component.html' })
export class CustomCoreComponent extends CoreComponent {
  constructor(
    protected route: ActivatedRoute,
    protected router: Router,
    protected requestHandler: CoreRequestHandlerService,
    protected cinemaDataProvider: CinemaDataProvider,
    protected languageDataProvider: LanguageDataProvider,
    protected translate: TranslateService,
    protected messageService: MessageService,
    protected bsLocaleService: BsLocaleService,
    protected loaderService: LoaderService,
    protected stateService: StateService
  ) {
    super(
      environment,
      route,
      router,
      requestHandler,
      cinemaDataProvider,
      languageDataProvider,
      translate,
      messageService,
      bsLocaleService,
      loaderService,
      stateService
    );

    this.loaderService.showLoader(this.loaderEnum.MAIN);
    this.setLanguageFromRoute(this.route.snapshot.paramMap.get('lang'));
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
      if (event.url.startsWith('/error')) {
        this.loaderService.hideLoader(LoaderEnum.MAIN);
      }

      const lang = this.route.snapshot.paramMap.get('lang') || sessionStorage.getItem(storageKey.lang);
      this.setLanguageFromRoute(lang);
    });
  }

  private setLanguageFromRoute(lang: string | null) {
    const supported = environment.constants.language.available;
    if (lang && supported.includes(lang) && this.translate.currentLang !== lang) {
      this.translate.use(lang);
    }
  }
}
